import { demoSession } from '../../demo/demo-session'
import { HttpInterceptorFn } from '@angular/common/http'

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  if (demoSession()) return next(req)
  const user = JSON.parse(localStorage.getItem('token') || '{}')
  const authToken = user?.accessToken?.token

  if (authToken === undefined) return next(req)

  const authReq = req.clone({
    setHeaders: {
      Accept: 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
  })

  return next(authReq)
}
